<template>
    <div class="c-o-request-header">
        <div class="c-o-request-header__inner">
            <div class="c-o-request-header__content">
                <h1 class="c-o-request-header__title h1">
                    {{ request.Title }}
                </h1>
                <div class="c-o-request-header__byline">
                    <div class="c-o-request-header__byline-block">
                        <icon :icon="'calendar'"></icon>
                        <span>{{
                            request.CreatedDate | formatDateWithoutTime
                        }}</span>
                    </div>
                    <div
                        v-if="request.Region"
                        class="c-o-request-header__byline-block"
                    >
                        <icon :icon="'pin_drop'"></icon>
                        {{ request.Region.Name }}
                    </div>
                    <div
                        v-if="request.Category"
                        class="c-o-request-header__byline-block"
                    >
                        <icon :icon="'hammer'"></icon>
                        <span>{{ request.Category.Name }}</span>
                    </div>
                </div>
                <button-group class="c-m-button-group--margin-bottom no-print">
                    <status-pill
                        v-if="!request.IsDirectRequest"
                        :status="'request'"
                        >Förfrågan</status-pill
                    >
                    <status-pill
                        v-if="request.IsDirectRequest"
                        :status="'request'"
                        >Direkt Förfrågan</status-pill
                    >
                    <status-pill v-if="request.SecureJob" :status="'active'"
                        >TryggtJobb</status-pill
                    >
                    <status-pill v-if="request.Active" :status="'active'"
                        >Aktiv</status-pill
                    >
                    <status-pill v-else :status="'inactive'"
                        >Inaktiv</status-pill
                    >
                </button-group>
            </div>

            <button-group class="c-m-button-group--margin-bottom no-print">
                <atom-button
                    v-if="
                        !contractRequested &&
                            request.IsOwner &&
                            request.SecureJob &&
                            companiesValidForContract.length > 0
                    "
                    :disabled="false"
                    label="Be om avtalsförslag"
                    class="c-a-button--theme-white no-print"
                    @buttonClicked="showContractModal = true"
                ></atom-button>
                <atom-button
                    v-if="request.IsOwner"
                    :icon="'star'"
                    :label="'Lämna omdöme'"
                    :disabled="!isRateable"
                    class="c-a-button--theme-primary no-print"
                    @buttonClicked="showRatingModal = true"
                ></atom-button>
            </button-group>
        </div>
        <div class="c-o-request-header__buttons-wrap no-print">
            <atom-button
                v-if="isAuthenticated && user"
                :class="'c-a-button--small'"
                :icon="'arrow_back'"
                :label="'Alla förfrågningar'"
                @buttonClicked="goBackToRequests"
            ></atom-button>
            <atom-button
                v-if="isAuthenticated && user"
                :class="
                    'c-a-button--small c-a-button--icon-right c-a-button--theme-white'
                "
                :icon="'file'"
                :label="'Skriv ut'"
                @buttonClicked="printPage"
            ></atom-button>
        </div>
        <modal
            class="c-m-modal--small"
            v-if="showRatingModal"
            @close="showRatingModal = false"
        >
            <rating-form
                :request="request"
                @completed="isRateable = false"
            ></rating-form>
        </modal>

        <modal
            class="c-m-modal--small"
            v-if="showContractModal"
            @close="showContractModal = false"
        >
            <contract-form
                :request="request"
                :companies="companiesValidForContract"
                @completed="showContractModal = false"
            />
        </modal>
    </div>
</template>
<script>
import Filters from "../../../../filters/index.js";

import { mapGetters } from "vuex";
import {
    GET_USER,
    IS_AUTHENTICATED
} from "../../../../store/store-models/authentication-model";

import {
    GET_CONTRACT,
    GET_IS_CONTRACT_REQUESTED
} from "../../../../store/store-models/contract-model";

import AtomButton from "../../atoms/AtomButton.vue";
import Icon from "../../atoms/AtomIcon.vue";
import StatusPill from "../../atoms/AtomStatus.vue";
import ButtonGroup from "../../molecules/MoleculeButtonGroup.vue";
import Modal from "../../molecules/MoleculeModal.vue";
import ContractForm from "../OrganismContractForm.vue";
import RatingForm from "../OrganismRatingForm.vue";

export default {
    props: ["request", "openModal"],
    filters: Filters,
    components: {
        Icon,
        StatusPill,
        ButtonGroup,
        Modal,
        RatingForm,
        ContractForm,
        AtomButton
    },
    data() {
        return {
            showRatingModal: this.openModal,
            rateable: true,
            showContractModal: false
        };
    },
    computed: {
        isRateable: {
            get() {
                return (
                    this.request.Companies &&
                    this.request.Companies.length > 0 &&
                    this.request.Rating == null &&
                    this.rateable
                );
            },
            set(value) {
                this.rateable = value;
            }
        },
        ...mapGetters({
            isAuthenticated: IS_AUTHENTICATED,
            userData: GET_USER,
            contractRequested: GET_IS_CONTRACT_REQUESTED,
            contract: GET_CONTRACT
        }),
        user: function() {
            if (this.userData && Object.keys(this.userData).length > 0) {
                return this.userData;
            }

            return false;
        },
        companiesValidForContract: function() {
            return this.request.Companies.filter(x => x.HasAnswered).map(x => {
                return {
                    value: x.CompanyId,
                    text: x.CompanyName
                };
            });
        }
    },
    methods: {
        goBackToRequests() {
            if (window.history.length > 2) {
                this.$router.go(-1);
            } else {
                this.$router.push({
                    name: "Förfrågningar"
                });
            }
        },
        printPage() {
            window.print();
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/views/components/organisms/request-sections/OrganismRequestHeader.vue